import { render, staticRenderFns } from "./GHX_PollutionLevel.vue?vue&type=template&id=712e5f10&scoped=true&"
import script from "./GHX_PollutionLevel.vue?vue&type=script&lang=js&"
export * from "./GHX_PollutionLevel.vue?vue&type=script&lang=js&"
import style0 from "./GHX_PollutionLevel.vue?vue&type=style&index=0&id=712e5f10&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712e5f10",
  null
  
)

export default component.exports